<script>
import SendEmail from '../../../components/Admin/SendEmail.vue';
export default {
  extends: SendEmail
};
</script>

<style>
</style>
